/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  AutoComplete,
  Button,
  Col,
  Divider,
  Dropdown,
  Input,
  Popover,
  Row,
  Modal,
  Table,
  Tooltip,
  Image,
  Typography,
  Skeleton,
} from "antd";
import {
  FileTextOutlined,
  DownOutlined,
  SettingOutlined,
  PlusOutlined,
  DeleteOutlined,
  ArrowDownOutlined,
  // ArrowUpOutlined,
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import PropTypes from "prop-types";
import "./index.css";
import { items, partyHeaders } from "./data";
import customModalLogo from "../../assets/images/custom-field-banner.webp";
import { Prompt, useHistory } from "react-router";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import useBeforeUnload from "../../components/Prompting";
import { loadParties, loadPartiesCollect } from "../../store/parties/actions";
import { useDispatch, useSelector } from "react-redux";
// import SimpleReactValidator from "simple-react-validator";
import { ToastContainer } from "react-toastify";
import { BiRightArrowAlt } from "react-icons/bi";

const Parties = (props) => {
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  //validator
  // const simpleValidator = useRef(new SimpleReactValidator());
  // const [, forceUpdate] = useState();

  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const userInfoDetails = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";
  const profileName =
    props.location && props.location.state
      ? props.location.state.user.organizations[0].organizationId
      : "";
  console.log(userId, "userId");

  const organizationId = !isEmpty(userInfoDetails)
    ? userInfoDetails
    : profileName;
  const itemList = { organizationId: organizationId };

  //api loader
  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setLoading(false);
      setTableLoading(false);
    }, 2000);
    dispatch(loadParties(itemList));
    dispatch(loadPartiesCollect(itemList));
    // dispatch(loadPartiesCategory(itemList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const { parties_list = [], parties_collect_list = [] } = useSelector(
    (state) => state.Parties
  );

  const [partiesTab, setPartiesTab] = useState("All Parties");
  const [pageRouting, setPageRouting] = useState(false);

  //Custom Fields State values
  const [customFields, setCustomFields] = useState(false);
  // const [customFieldsAdd, setCustomFieldsAdd] = useState(false);
  const [pageRender, setPageRender] = useState(false);

  const handleOk = () => {
    setCustomFields(false);
  };
  const handleCancel = () => {
    setCustomFields(false);
  };

  const [customFieldsData, setCustomFieldsData] = useState([
    {
      fieldName: "",
    },
  ]);

  const addCustomFields = () => {
    setCustomFieldsData([
      ...customFieldsData,
      {
        fieldName: "",
      },
    ]);
    // setCustomFieldsAdd(true);
    setPageRender(!pageRender);
  };

  const removeCustomFields = (index) => {
    const array = customFieldsData;
    if (index !== 0) {
      if (index > -1) {
        array.splice(index, 1);
      }
    }
    setPageRender(!pageRender);
  };

  const handleCustomFieldsChange = (e, name, index) => {
    var fieldList = customFieldsData;
    if (name === "fieldName") {
      fieldList[index][name] = e.target.value;
      setCustomFieldsData(fieldList);
      setPageRender(!pageRender);
    }
  };

  //header columns
  const HeaderData = [
    {
      key: "name",
      title: <p className="parties-column-header font-semibold">Party Name</p>,
      sort: true,
      // render: (_, record) => `Group ${Math.floor(record.id / 4)}`,
      dataIndex: "partyName",
    },
    {
      key: "displayName",
      title: (
        <p className="parties-column-header font-semibold">Display Name</p>
      ),
      sort: false,
      dataIndex: "displayName",
    },
    {
      key: "mobileNo",
      title: <p className="parties-column-header font-semibold">Mobile No</p>,
      sort: true,
      dataIndex: "mobileNo",
    },
    {
      key: "creditLimit",
      title: (
        <p className="parties-column-header font-semibold">Credit Limit</p>
      ),
      sort: false,
      dataIndex: "creditLimit",
    },
    // {
    //   key: "openingbalanceType",
    //   title: "Opening Balance Type",
    //   sort: false,
    //   dataIndex: "openingbalanceType",
    // },
    {
      key: "currentBalance",
      title: <p className="parties-column-header font-semibold">Balance</p>,
      sort: false,
      dataIndex: "currentBalance",
    },
  ];

  //row and data table section
  // const [categoryName, setCategoryName] = useState("");
  // const [description, setDescription] = useState("");
  // const [shortCode, setShortCode] = useState("");
  // const [itemCategory, setItemCategory] = useState([]);
  // const [itemCategoryModal, setItemCategoryModal] = useState(false);
  const [partiesRows, setPartiesRows] = useState([
    {
      partyName: "",
      partyNameValue: "",
      partyCode: "",
      billingAddress: "",
      _id: "",
      createdAt: "",
      createdBy: "",
      creditBalance: "",
      currentBalance: "",
      creditLimit: "",
      creditPeriod: "",
      currencyId: "",
      currencyName: "",
      displayName: "",
      email: "",
      gstPercentageId: "",
      gstPercentageName: "",
      gstTypeName: "",
      stateName: "",
      mobileNo: "",
      openingBalance: "",
      openingbalanceType: "",
      panNumber: "",
      gstIn: "",
      placeofSupply: "",
      shippingAddress: "",
      status: "",
      updatedAt: "",
    },
  ]);

  const [search, setSearch] = useState("");

  const itemsRoutes = (data) => {
    history.push({
      pathname: "/parties/data",
      state: {
        organizationId: organizationId,
        userId: userId,
        itemList: itemList,
        // categoryOptions: categoryOptions,
        data: data,
      },
    });
  };

  //parties table filter based on tab selection
  const partiesFilteredData =
    partiesTab === "To Collect" && parties_list && parties_list.length > 0
      ? parties_list.filter((data) => data.openingbalanceType === "To Collect")
      : [];

  const partiesDataTableList =
    partiesTab === "To Collect"
      ? partiesFilteredData
      : partiesTab === "All Parties"
      ? parties_list && parties_list
      : [];

  const partiesDataTable =
    partiesDataTableList && partiesDataTableList.length > 0
      ? partiesDataTableList.map((data, index) => {
          console.log(data.currentBalance, "currentBalance");

          return {
            index: index + 1,
            billingAddress: data.billingAddress,
            _id: data._id,
            createdAt: data.createdAt,
            createdBy: data.createdBy,
            creditBalance: data.creditBalance.toLocaleString(),
            // creditBalance: (
            //   <p onClick={() => itemsRoutes(data)} className="flex">
            //     <p className="mr-2">
            //       {data.openingbalanceType === "To Collect" ? (
            //         <ArrowDownOutlined className="text-[green]" />
            //       ) : (
            //         ""
            //       )}
            //     </p>{" "}
            //     {data.creditBalance ? data.creditBalance : "--"}
            //   </p>
            // ),
            currentBalance: (
              <p
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13px",
                }}
                onClick={() => itemsRoutes(data)}
                className="flex"
              >
                <p className="mr-2">
                  {data.openingbalanceType === "To Collect" ? (
                    <ArrowDownOutlined className="text-[green]" />
                  ) : (
                    ""
                  )}
                </p>{" "}
                {data.currentBalance.toLocaleString("en-IN")}
              </p>
            ),
            partyName: (
              <p
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13px",
                }}
                onClick={() => {
                  history.push({
                    pathname: "/parties/data",
                    state: {
                      data: data,
                      // categoryOptions: categoryOptions
                    },
                  });
                }}
              >
                {data.partyName ? data.partyName : "--"}
              </p>
            ),
            creditLimit: (
              <p
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13px",
                }}
                onClick={() => itemsRoutes(data)}
              >
                {data.creditLimit ? data.creditLimit.toLocaleString() : "--"}
              </p>
            ),
            creditPeriod: data.creditPeriod,
            partyNameValue: data.partyName,
            currencyId: data.currencyId,
            currencyName: data.currencyName,
            displayName: (
              <p
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13px",
                }}
                onClick={() => itemsRoutes(data)}
              >
                {data.displayName ? data.displayName : "--"}
              </p>
            ),
            email: data.email,
            gstPercentageId: data.gstPercentageId,
            gstPercentageName: data.gstPercentageName,
            gstTypeName: data.gstTypeName,
            mobileNo: (
              <p
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13px",
                }}
                onClick={() => itemsRoutes(data)}
              >
                {data.mobileNo ? data.mobileNo : "--"}
              </p>
            ),
            openingBalance: data.openingBalance,
            openingbalanceType: (
              <p
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13px",
                }}
                onClick={() => itemsRoutes(data)}
              >
                {data.openingbalanceType ? data.openingbalanceType : "--"}
              </p>
            ),
            panNumber: data.panNumber,
            gstIn: data.gstIn,
            placeofSupply: data.placeofSupply,
            shippingAddress: data.shippingAddress,
            status: data.status,
            updatedAt: data.updatedAt,
          };
        })
      : [];

  useEffect(() => {
    if (
      partiesDataTable &&
      partiesDataTable.length > 0 &&
      partiesTab === "All Parties"
    ) {
      setPartiesRows(partiesDataTable);
    } else if (partiesTab === "To Collect") {
      setPartiesRows(partiesDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partiesTab, parties_list]);

  //data table

  const handleSearch = (event) => {
    const filteredRows = partiesDataTable
      .filter((row) =>
        row.partyNameValue
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setPartiesRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  //category api integrations
  // const createCategory = () => {
  //   if (simpleValidator.current.allValid()) {
  //     const categoryList = {
  //       categoryName: categoryName,
  //       organizationId: organizationId,
  //       shortCode: shortCode,
  //       description: description,
  //       createdBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
  //     };

  //     dispatch(createPartiesCategoryList(categoryList));
  //     setTimeout(() => {
  //       dispatch(loadPartiesCategory(itemList));
  //       setItemCategoryModal(false);
  //       toast.success("Category created successfully");
  //     }, 1000);
  //   } else {
  //     simpleValidator.current.showMessages();
  //     forceUpdate(1);
  //   }
  // };

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useBeforeUnload({
    when: !isEmpty(search),
    message: "Are you sure you want to leave?",
  });

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Parties | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid pb-[220px] rounded-sm bg-[#ffffff]">
        {/* <Skeleton.Input
          style={{
            padding: "5px",
            width: "100%",
          }}
          active={true}
          size={"large"}
        > */}
        <Col span={24}>
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-4">
            <div className="flex">
              <ArrowLeftOutlined
                onClick={() => setPageRouting(true)}
                className="font-bold text-[18px]"
              />
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[18px] ml-2 mt-2 font-semibold"
              >
                Parties
              </h1>
            </div>
            <div className="flex">
              <Dropdown
                menu={{
                  items,
                }}
                trigger={["click"]}
                className="text-[#0c8ce9] rounded-md"
              >
                <Tooltip
                  title="See all your party specific reports"
                  placement="left"
                  rootClassName="text-[10px]"
                >
                  <div
                    style={{
                      border: "1px solid #9ed1f6",

                      fontFamily: "Poppins",
                    }}
                    className="border flex justify-between w-[180px] pl-3 pr-2 pt-2 pb-2 cursor-pointer"
                  >
                    <div>
                      <FileTextOutlined /> Reports
                    </div>
                    <DownOutlined />
                  </div>
                </Tooltip>

                {/* </a> */}
              </Dropdown>
              <Tooltip
                title="Easily add custom fields to all your parties"
                placement="bottom"
                rootClassName="text-[10px]"
                style={{
                  cursor: "not-allowed",
                }}
              >
                <div
                  style={{
                    // cursor: "not-allowed",
                    pointerEvents: "none",
                  }}
                  onClick={() => setCustomFields(true)}
                  className="opacity-1 bg-[#efefef] border rounded-md ml-3 p-2.5"
                >
                  <SettingOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        </Col>
        {/* </Skeleton.Input> */}
        <div
          className={
            windowDimensions.height >= 650 && windowDimensions.height < 700
              ? "parties-home-tab-device-main-card"
              : (windowDimensions.height >= 700 &&
                  windowDimensions.height <= 767) ||
                (windowDimensions.height > 767 && windowDimensions.height < 830)
              ? "parties-home-medium-device-main-card"
              : windowDimensions.height >= 800 && windowDimensions.height < 900
              ? "parties-home-large-device-main-card"
              : windowDimensions.height >= 900 && windowDimensions.height < 1000
              ? "parties-home-extra-large-device-main-card"
              : windowDimensions.height >= 1000
              ? "parties-home-extra-infinite-large-device-main-card"
              : "parties-home-main-card"
          }
        >
          <Col span={24} className="">
            <Row className="pl-5 mt-3 mb-5">
              {partyHeaders.map((data) => {
                return (
                  <Col span={12} key={data.key} className="">
                    {loading ? (
                      <Skeleton.Input
                        style={{
                          marginRight: "5px",
                          minWidth: "255%",
                          height: "60px",
                        }}
                        // className="tabs-skeleton"
                        active={true}
                        size={"large"}
                        // block={true}
                      ></Skeleton.Input>
                    ) : (
                      <div
                        className={
                          partiesTab === data.label
                            ? "poppins mr-4 parties-select-card parties-card border rounded-md"
                            : data.key !== 3
                            ? "poppins mr-4 parties-card border rounded-md"
                            : "poppins parties-select-card parties-card border rounded-md"
                        }
                        onClick={() => {
                          setPartiesTab(data.label);
                          setTableLoading(true);
                          setTimeout(() => {
                            setTableLoading(false);
                          }, 2000);
                        }}
                      >
                        <div
                          style={{
                            fontSize: "14px",
                            display: "flex",
                            color: data.color,
                            fontFamily: "Poppins",
                          }}
                        >
                          <p className={data.key !== 1 ? "mt-[2px]" : ""}>
                            {data.icon}
                          </p>
                          <h2 className={"ml-2"}>{data.label}</h2>
                        </div>
                        <div>
                          <h1 className="font-semibold text-[18px]">
                            {data.key == 1
                              ? partiesDataTable.length
                              : data.key === 2 &&
                                parties_collect_list &&
                                parties_collect_list.totalAmounttoCollect !==
                                  undefined
                              ? "₹ " +
                                parties_collect_list.totalAmounttoCollect.toLocaleString()
                              : 0}
                          </h1>
                        </div>
                      </div>
                    )}

                    {/* </Skeleton.Input> */}
                  </Col>
                );
              })}
            </Row>
          </Col>
          {/* Parties input section with bulk actions */}
          <Col span={24}>
            <Row
              className={
                loading
                  ? "flex justify-between mt-1 ml-4 pr-8"
                  : "flex justify-between mt-1 ml-4"
              }
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    marginRight: "5px",
                    width: "100%",
                    height: "40px",
                  }}
                  active={true}
                  size={"large"}
                  // block={true}
                ></Skeleton.Input>
              ) : (
                <div className="flex">
                  <Tooltip
                    rootClassName="text-[10px]"
                    title="Search by phone or name"
                    placement="bottom"
                  >
                    {/* {searchOpen ? ( */}
                    <AutoComplete
                      style={{
                        width: 170,
                        marginRight: "10px",
                        fontFamily: "Poppins",
                      }}
                    >
                      <Input.Search
                        size="large"
                        placeholder="Search Party"
                        style={{
                          fontFamily: "Poppins",
                        }}
                        name="search"
                        value={search}
                        onChange={(e) => handleSearch(e)}
                      />
                    </AutoComplete>
                    {/* ) : (
                      <div
                        onClick={() => setSearchOpen(true)}
                        className="border rounded-md h-[40px] mr-3 pt-2 pb-2 pr-3 pl-3 cursor-pointer"
                      >
                        <SearchOutlined size={16} />
                      </div>
                    )} */}
                  </Tooltip>
                  {/* <Select
                    style={{
                      width: 250,
                      height: 40,
                    }}
                    value={itemCategory}
                    onChange={(e) => {
                      setItemCategory(e);
                      if (!isEmpty(e)) {
                        const filterRows =
                          partiesRows.length > 0 &&
                          partiesRows.filter((data) => data.categoryId === e);
                        console.log(filterRows, "filterRows");
                        const filteredData =
                          filterRows.length > 0 && filterRows;
                        setPartiesRows(filteredData);
                        setTableLoading(true);
                        setTimeout(() => {
                          setTableLoading(false);
                        }, 1000);
                      }
                    }}
                    suffixIcon={
                      !isEmpty(itemCategory) ? (
                        <CloseCircleOutlined
                          onClick={() => {
                            setItemCategory([]);
                            setPartiesRows(partiesDataTable);
                            setTableLoading(true);
                            setTimeout(() => {
                              setTableLoading(false);
                            }, 1000);
                          }}
                          className="text-[12px]"
                        />
                      ) : (
                        <SearchOutlined className="text-[12px]" />
                      )
                    }
                    onSearch={true}
                    placeholder="Select Categories"
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <Divider
                          style={{
                            margin: "8px 0",
                          }}
                        />
                        <div className="w-[100%]">
                          <Button
                            type="dashed"
                            className="w-[100%]"
                            icon={<PlusOutlined />}
                            onClick={() => setItemCategoryModal(true)}
                          >
                            Add item
                          </Button>
                        </div>
                      </>
                    )}
                    options={categoryOptions}
                  /> */}
                </div>
              )}
              <div className="flex">
                {loading ? (
                  <Skeleton.Input
                    style={{
                      marginRight: "5px",
                      width: "100%",
                      height: "40px",
                    }}
                    active={true}
                    size={"large"}
                    // block={true}
                  ></Skeleton.Input>
                ) : (
                  <Popover
                    placement="bottomRight"
                    trigger={"click"}
                    content={
                      <div
                        onClick={() =>
                          history.push({
                            pathname: "/parties/import",
                            // state: { mode: "IMEI" },
                          })
                        }
                        className="hover:rounded-md hover:bg-[lightgray] hover:mr-[-3px] flex justify-between w-[270px] h-[48px] mt-[-8px] pl-3 pr-2 pt-2 hover:pb-4 pb-2 cursor-pointer"
                      >
                        <div
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="hover:pb-5"
                        >
                          <p className="flex text-[14px] font-semibold">
                            <FileExcelOutlined className="mr-2" /> Bulk Add
                            Parties
                          </p>
                          <p className="text-[12px]">
                            Quickly add all your Parties with Excel
                          </p>
                        </div>
                        <BiRightArrowAlt size={24} />
                      </div>
                    }
                  >
                    <Tooltip
                      title="Easily perform bulk actions on all your Parties"
                      placement="left"
                      rootClassName="text-[10px]"
                    >
                      <div
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="border rounded-sm flex justify-between w-20px] pl-3 pr-2 pt-2 pb-2 cursor-pointer"
                      >
                        <div>
                          <FileTextOutlined /> Bulk Action
                        </div>
                        <DownOutlined />
                      </div>
                    </Tooltip>
                  </Popover>
                )}
                {loading ? (
                  <Skeleton.Input
                    style={{
                      marginLeft: "15px",
                      width: "100%",
                      height: "40px",
                    }}
                    active={true}
                    size={"large"}
                    // block={true}
                  ></Skeleton.Input>
                ) : (
                  <Button
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="ml-3 bg-[blueviolet] p-5 text-[white] mr-3"
                  >
                    <Link
                      to={{
                        pathname: "/add-parties",
                        state: {
                          organizationId: organizationId,
                          userId: userId,
                          itemList: itemList,
                          // categoryOptions: categoryOptions,
                        },
                      }}
                    >
                      Create Party
                    </Link>
                  </Button>
                )}
              </div>
            </Row>
          </Col>
          <Col span={24} className="pt-3 pb-3 pr-4 pl-4">
            <Table
              style={{
                overflow: "hidden",
                cursor: "pointer",
              }}
              bordered
              columns={HeaderData}
              dataSource={
                partiesRows &&
                partiesRows.length > 0 &&
                !isEmpty(partiesRows[0].partyNameValue)
                  ? partiesRows
                  : []
              }
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["5", "10", "20", "30"],
              }}
              sortDirections={"ascend"}
              // onHeaderRow={}
              loading={tableLoading ? true : false}
              rowKey={(record) => record._id}
              scroll={{
                y:
                  partiesRows.length <= 3
                    ? 150
                    : partiesRows.length > 3
                    ? "100%"
                    : "",
                x: 765,
              }}
              showSorterTooltip={"sorter-icon"}
            />
          </Col>
        </div>
        {/* Custom fields modal */}
        <Modal
          open={customFields}
          title="Add Custom Fields"
          onOk={handleOk}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          okButtonProps={{
            disabled: customFieldsData.length > 0 ? false : true,
          }}
          onCancel={handleCancel}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <div className="w-[110%] ml-[-23.5px] mt-[-24px] mb-4">
            <Image src={customModalLogo} />
          </div>
          <div>
            <Typography className="mb-2">Field Name</Typography>
            {customFieldsData.map((data, index) => {
              return (
                <div key={index} className="mb-2">
                  <div className="flex justify-between mb-[10px]">
                    <Input
                      name="fieldName"
                      value={data.fieldName}
                      placeholder="Enter Custom Field name"
                      className="w-[90%]"
                      onChange={(e) =>
                        handleCustomFieldsChange(e, "fieldName", index)
                      }
                    />
                    <DeleteOutlined
                      onClick={() => removeCustomFields(index)}
                      type="primary"
                      className="ml-3 border rounded-md p-2 text-[red] cursor-pointer"
                      size={"large"}
                    />{" "}
                  </div>
                </div>
              );
            })}
          </div>
          {/* ) : (
            ""
          )} */}

          <Row
            onClick={() => addCustomFields()}
            className="w-[100%] mt-2 bg-gray-50 p-2 border border-dashed border-blue-400 pl-5 pr-5 mt-3 mb-3"
          >
            <h1 className="cursor-pointer text-[14px] text-[#084d7b] font-semibold">
              {" "}
              <PlusOutlined /> Add Custom Field
            </h1>
          </Row>
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>
        <Modal
          open={pageRouting}
          onOk={() => {
            setPageRouting(false);
            history.push("/parties");
          }}
          closeIcon
          maskClosable={false}
          rootClassName="p-15 h-[300px]"
          okText={"Yes, Leave"}
          cancelText={"No, Stay"}
          onCancel={() => setPageRouting(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <div className="mr-3">
                <OkBtn />
              </div>
              <CancelBtn />
            </div>
          )}
          width={500}
        >
          <div className="text-center w-[100%]">
            <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
            <h1 className="text-center text-[18px] font-bold">
              Are you sure you want to leave this page?
            </h1>
            <p className="text-center text-[14px] mt-2">
              All unsaved changes will be lost!
            </p>
          </div>
        </Modal>
      </Row>
      <Prompt
        when={!isEmpty(search)}
        message="Are you sure you want to leave?"
      />
      {/* New category modal */}
      {/* <Modal
        open={itemCategoryModal}
        title={"Create Category"}
        onOk={() => {
          createCategory();
        }}
        closeIcon
        maskClosable={false}
        okText={"Save"}
        width={450}
        onCancel={() => setItemCategoryModal(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <OkBtn />
          </>
        )}
      >
        <Divider
          style={{
            borderWidth: "0.2px",
            marginTop: "1px",
            width: "112%",
            marginLeft: "-24px",
          }}
        />
        <Col span={24} className="mt-[-5px]">
          <Typography
            className="uppercase mb-1"
            style={{
              fontFamily: "Poppins",
              fontSize: "12px",
            }}
          >
            Category Name
          </Typography>
          <Input
            name="categoryName"
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            placeholder="Enter Category Name"
            className="p-2"
          />
          <p className="text-start text-[red] mt-2 mb-3">
            {simpleValidator.current.message(
              "categoryName",
              categoryName,
              "required"
            )}
          </p>
        </Col>
        {categoryAdditionalFields ? (
          <>
            {" "}
            <Col span={24} className="flex justify-end">
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                onClick={() => setCategoryAdditionalFields(false)}
                className="cursor-pointer text-[#d54041] text-[13px]"
              >
                Remove
              </div>
            </Col>
            <Col span={24}>
              <Typography
                className="uppercase mb-1"
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
              >
                Short Code
              </Typography>
              <Input
                name="shortCode"
                value={shortCode}
                onChange={(e) => setShortCode(e.target.value)}
                placeholder="Enter Short Code"
                className="p-2"
              />
            </Col>
            <Col span={24} className="mb-[50px] mt-2">
              <Typography
                className="uppercase mb-1"
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
              >
                Description
              </Typography>
              <Input.TextArea
                name="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter Description"
                className="p-3"
              />
            </Col>
          </>
        ) : (
          <div
            style={{
              fontFamily: "Poppins",
            }}
            onClick={() => setCategoryAdditionalFields(true)}
            className="cursor-pointer flex text-[#4096ff] mt-2 text-[13px] mb-4"
          >
            <PlusOutlined className="mr-2" /> Additonal Fields
          </div>
        )}
      </Modal> */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{
          fontSize: "12px",
        }}
      />
    </React.Fragment>
  );
};

Parties.propTypes = {
  location: PropTypes.any,
};

export default Parties;
